var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkshopFeatureImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98435 33.4623C7.00438 31.0965 6.5 28.5608 6.5 26C6.5 23.4392 7.00438 20.9035 7.98435 18.5377C8.96432 16.1718 10.4007 14.0222 12.2114 12.2114C14.0222 10.4007 16.1718 8.96432 18.5377 7.98435C20.9035 7.00438 23.4392 6.5 26 6.5C28.5608 6.5 31.0965 7.00438 33.4623 7.98435C35.8282 8.96432 37.9778 10.4007 39.7886 12.2114C41.5993 14.0222 43.0357 16.1718 44.0157 18.5377C44.9956 20.9035 45.5 23.4392 45.5 26C45.5 28.5608 44.9956 31.0965 44.0157 33.4623C43.0357 35.8282 41.5993 37.9778 39.7886 39.7886C37.9778 41.5993 35.8282 43.0357 33.4623 44.0157C31.0965 44.9956 28.5608 45.5 26 45.5C23.4392 45.5 20.9035 44.9956 18.5377 44.0157C16.1718 43.0357 14.0222 41.5993 12.2114 39.7886C10.4007 37.9778 8.96432 35.8282 7.98435 33.4623Z",
    fill: "#DF1995"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 26.0001L23.8333 30.3334L32.5 21.6667",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshopFeatureImage);
export default __webpack_public_path__ + "static/media/workshop-feature-image.eb522dcbe431cd6365077d37a61e5222.svg";
export { ForwardRef as ReactComponent };